/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderDirectoryContact } from './ProviderDirectoryContact';
import {
    ProviderDirectoryContactFromJSON,
    ProviderDirectoryContactFromJSONTyped,
    ProviderDirectoryContactToJSON,
    ProviderDirectoryContactToJSONTyped,
} from './ProviderDirectoryContact';

/**
 * 
 * @export
 * @interface CreateDirectoryContact201Response
 */
export interface CreateDirectoryContact201Response {
    /**
     * 
     */
    data?: ProviderDirectoryContact;
}

/**
 * Check if a given object implements the CreateDirectoryContact201Response interface.
 */
export function instanceOfCreateDirectoryContact201Response(value: object): value is CreateDirectoryContact201Response {
    return true;
}

export function CreateDirectoryContact201ResponseFromJSON(json: any): CreateDirectoryContact201Response {
    return CreateDirectoryContact201ResponseFromJSONTyped(json, false);
}

export function CreateDirectoryContact201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDirectoryContact201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ProviderDirectoryContactFromJSON(json['data']),
    };
}

export function CreateDirectoryContact201ResponseToJSON(json: any): CreateDirectoryContact201Response {
    return CreateDirectoryContact201ResponseToJSONTyped(json, false);
}

export function CreateDirectoryContact201ResponseToJSONTyped(value?: CreateDirectoryContact201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ProviderDirectoryContactToJSON(value['data']),
    };
}

